import type { InputTextDesignTokens } from '@primeuix/themes/aura/inputtext';

export default {
  root: {
    background: '{form.field.background}',
    disabledBackground: '{form.field.disabled.background}',
    filledBackground: '{form.field.filled.background}',
    filledHoverBackground: '{form.field.filled.hover.background}',
    filledFocusBackground: '{form.field.filled.focus.background}',
    borderColor: '{form.field.border.color}',
    hoverBorderColor: '{form.field.hover.border.color}',
    focusBorderColor: '{form.field.focus.border.color}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    color: '{form.field.color}',
    disabledColor: '{form.field.disabled.color}',
    placeholderColor: '{form.field.placeholder.color}',
    invalidPlaceholderColor: '{form.field.invalid.placeholder.color}',
    shadow: '{form.field.shadow}',
    paddingX: '{form.field.padding.x}',
    paddingY: '{form.field.padding.y}',
    borderRadius: '{form.field.border.radius}',
    focusRing: {
      width: '{form.field.focus.ring.width}',
      style: '{form.field.focus.ring.style}',
      color: '{form.field.focus.ring.color}',
      offset: '{form.field.focus.ring.offset}',
      shadow: '{form.field.focus.ring.shadow}',
    },
    transitionDuration: '{form.field.transition.duration}',
    sm: {
      fontSize: '0.875rem',
      paddingX: '{form.field.sm.padding.x}',
      paddingY: '{form.field.sm.padding.x}',
    },
    lg: {
      fontSize: '1.125rem',
      paddingX: '{form.field.lg.padding.x}',
      paddingY: '{form.field.lg.padding.x}',
    },
  },
} satisfies InputTextDesignTokens;
